<template>
  <div
    class="couleur-fond align-items-center h-100 position-relative"
    :class="typeCarte"
    :style="{ '--couleur': produit.image4Color ? produit.image4Color : '#060606' }"
  >
    <b-container class="m-auto d-flex justify-content-center align-items-center h-100">
      <b-row class="m-0 pr-2 w-100 h-100 text-white justify-content-center">
        <b-col
          cols="8"
          class="graphik_bold image-banniere d-flex align-items-center justify-content-center mh-100"
        >
          <div class="h-100 w-100 text-center">
            <b-img-lazy class="mh-100 mw-100" :src="jel_getFichierSrc(produit.image4)" alt="" />
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'BanniereInfoMASEnDirect',
  props: {
    content: { type: Object, required: true },
  },
  data() {
    return {
      grosseurCarte: null,
      typeCarte: null,
    };
  },
  computed: {
    ...mapGetters({
      getProduitCasinoByUuid: 'produitCasino/getByUuid',
    }),
    produit() {
      // On peut recevoir un produit complet ou uniquement son UUID
      return this.content.produit ?? this.getProduitCasinoByUuid(this.content.idProduit);
    },
    isCarte4x3() {
      return !this.content.isListeHorizontale && this.$el.clientWidth > 450;
    },
  },
};
</script>

<style lang="scss" scoped>
$facteurTaille: 1.2;

.container {
  max-width: none;
  padding: 0;
  height: 2.8rem;
}

//Fonctionne sur tous les fureteurs sauf Safari 14
@supports (aspect-ratio: 4/10) {
  .container-chiffre {
    aspect-ratio: 4/10;
  }
}

// Fonctionne sur Safari 14
@supports not (aspect-ratio: 4/10) {
  .container-chiffre {
    width: 15%;
  }
}

.couleur-fond {
  background-color: var(--couleur);
  bottom: 0;
  width: -webkit-fill-available;
}
</style>
